// main.js — application bootstrap entry. Loads the session (so the router's auth
// guards and the first paint see the real user), then starts the SPA router over
// the full route table. Kept deliberately tiny: all behavior lives in the core
// (router/auth) and in the lazily-loaded page chunks.

import { bootstrapAuth } from './core/auth-context.js';
import { createRouter } from './core/router.js';
import { ROUTES } from './routes.js';

async function boot() {
  const outlet = document.getElementById('app');
  if (!outlet) return;

  // Resolve the current user before the first render so auth-guarded routes
  // don't flash /login (or strand an authed user). Fail-closed: errors leave
  // user=null inside bootstrapAuth.
  await bootstrapAuth();

  createRouter({
    routes: ROUTES,
    outlet,
    notFound: { tag: 'pg-page-not-found', load: () => import('./pages/not-found.js') },
  }).start();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
